export const navigationOptions = [
  {
    name: "Dashboard",
    path: "/dashboard",
  },
  {
    name: "Trainers",
    path: "/trainers",
  },
  {
    name: "Users",
    path: "/users",
  },
  {
    name: "Settings",
    path: "/settings",
  },
];
